import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { debounce } from 'throttle-debounce';
import strings from '../Globalization';
import consts from '../consts';
import Model from '../models/model';
import connectionService from '../services/Connection';
import util from '../util';
import { customizeSave, onChangePublish, onChangeSubscription } from './AuthorizedClientTable.js';

const topicType = consts.TopicType;

const { onChangeSerialNumber, onChangeTopic } = util;

const isLimitedUser = () => {
	const roles = util.localData?.loginData?.roles;
	const isLimited = Array.isArray(roles)
		? roles.includes('Administrator') || roles.includes('Viewer')
		: roles === 'Administrator' || roles === 'Viewer';
	return isLimited;
};
const autocompleteValueFormatter = (value) => {
	let formatedValue = [];
	if (Array.isArray(value)) {
		formatedValue = value.map((entry) => entry?.id || entry);
	}
	return formatedValue;
}
export const Bull = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'value'
})(({ theme, value }) => ({
	width: theme.spacing(2),
	height: theme.spacing(2),
	borderRadius: theme.spacing(2),
	backgroundColor: value ? theme.palette.success.main : theme.palette.error.main,
}));
const onCreateOption = (LookupTypeId) => (value) => {
	let action = 'save'
	let id = 0
	const formData = new FormData();
	formData.append('action', action);
	formData.append('id', id);
	formData.append('LookupTypeId', LookupTypeId);
	formData.append('CustomStringValue', value.option.id);
	formData.append('DisplayValue', value.option.id);
	try {
		fetch(connectionService.TopicPermissionLookup, {
			method: 'POST',
			body: formData,
			credentials: 'include'
		})
	} catch (error) {
		console.error('Error creating record:', error);
	}
}

const customizeInput = ({ Input, inputProps }) => {
	const field = inputProps.field
	if (inputProps.formik.values[field].length === 1 && inputProps.formik.values[field][0] === '')
		inputProps.formik.values[field] = []
	return (
		<Input {...inputProps} />
	)
}

const getDevicePermissions = ({ DeviceTypePermission, EquipmentType = '' }) => {
	if (DeviceTypePermission) {
		return DeviceTypePermission.map(obj => {
			const subscriptionTopic = [];
			const publishTopic = [];
			obj.Publish.length && publishTopic.push('+/data');
			obj.PublishTData.length && publishTopic.push('+/tdata');
			obj.PublishData.length && publishTopic.push('+/data');
			obj.PublishCmdData.length && publishTopic.push('+/cmd');
			obj.Subscription.length && subscriptionTopic.push('+/data');
			obj.SubscribeData.length && subscriptionTopic.push('+/data');
			obj.SubscribeTData.length && subscriptionTopic.push('+/tdata');
			obj.SubscribeCmdData.length && subscriptionTopic.push('+/cmd');
			if (EquipmentType?.toLowerCase() === 'ct') {
				publishTopic.push('data/#');
			}
			return {
				[obj.EquipmentType]: {
					Subscription: obj.Subscription,
					Publish: obj.Publish,
					DataPermission: obj.PublishData,
					TDataPermission: obj.PublishTData,
					CmdPermission: obj.PublishCmdData,
					SubDataPermission: obj.SubscribeData,
					SubTDataPermission: obj.SubscribeTData,
					SubCmdPermission: obj.SubscribeCmdData,
					PublishDeviceType: obj.PublishDeviceType
				}
			};
		});
	}
}
const populateTopic = ({ formik, activeRecord ={}, value }) => {
	const { record } = activeRecord;
	const { DeviceTypePermission = [] } = activeRecord?.combos || {};
	const devicePermission = getDevicePermissions({ DeviceTypePermission, EquipmentType: value });
	let permissions = devicePermission.find(
		obj => Object.keys(obj)[0] === value
	);

	if (permissions) {
		permissions = Object.values(permissions)[0];

		let _loop = function _loop(permission) {
			if (permissions[permission]) {
				permissions[permission].map(function (obj) {
					return ((!record[permission] || !permissions[permission].includes(obj)) && !record[permission].includes(obj)) && permissions[permission].push(obj);
				});
				record[permission] = permissions[permission];
			}
		};

		for (const permission in permissions) {
			_loop(permission);
		}
	}
	record['SerialNumber'] = '';
	record['EquipmentType'] = value;
	if (record.TDataPermission[0] === '' && record.PublishDeviceType[0] === '' && record.DataPermission[0] === '' && record.CmdPermission[0] === '') {
		record.Publish = [];
	}
	if (record.SubTDataPermission[0] === '' && record.SubDataPermission[0] === '' && record.SubCmdPermission[0] === '') {
		record.Subscription = [];
	}
	if (value === "C") {
		let findItext = record.Subscription.findIndex(function (item) {
			return item === '+/tdata';
		});
		findItext = findItext > -1 ? record.Subscription.splice(findItext, 1) : record.Subscription;
		let findIndex = record.Publish.findIndex(function (item) {
			return item === '+/tdata';
		});
		findIndex = findIndex > -1 ? record.Publish.splice(findIndex, 1) : record.Publish;
	}
	formik?.setFieldValue?.('Subscription', record.Subscription);
	formik?.setFieldValue?.('SubTDataPermission', record.SubTDataPermission);
	formik?.setFieldValue?.('SubDataPermission', record.SubDataPermission);
	formik?.setFieldValue?.('SubCmdPermission', record.SubCmdPermission);

	//Publish 
	formik?.setFieldValue?.('Publish', record.Publish);
	formik?.setFieldValue?.('TDataPermission', record.TDataPermission);
	formik?.setFieldValue?.('PublishDeviceType', record.PublishDeviceType);
	formik?.setFieldValue?.('DataPermission', record.DataPermission);
	formik?.setFieldValue?.('CmdPermission', record.CmdPermission);
	formik?.setFieldValue?.('SerialNumber', '');
}

const model = new Model({
	name: 'ClientRequests',
	gridTitle: 'ClientRequests',
	api: 'ClientRequests',
	disableAdd: true,
	disableDelete: true,
	readOnly: isLimitedUser,
	formTitleField: 'ClientName',
	showGridRefreshBtn: true,
	defaultSort: 'LastConnection DESC',
	filter: [{ operator: '$eq', value: false, property: 'IsAuthorize', type: 'boolean' }],
	title: 'Client',
	comboTypes: [
		{ type: 'Hospital', loaded: true },
		{ type: 'DeviceType', loaded: true },
		{ type: 'LinkToTrackingSystems', loaded: true },
		{ type: 'PubTopics', loaded: true },
		{ type: 'SubTopics', loaded: true },
		{ type: 'DataTopics', loaded: true },
		{ type: 'TDataTopics', loaded: true },
		{ type: 'CMDDataTopics', loaded: true },
		{ type: 'DeviceTypePermission', loaded: true },
		{ type: 'LinkToRFIDSystems', loaded: true }
	],
	formGroups: [
		{
			fields: [
				'ClientName',
				'HospitalName',
				'EquipmentType',
				'LinkToRFIDSystems',
				'LinkToTrackingSystems',
				'MachineName',
				'SerialNumber',
				'MacAddress',
				'DeviceFamily',
				'DeviceModel'
			],
			columnSize: 12
		},
		{
			header: 'Subscribe',
			fields: ['Subscription', 'SubDataPermission', 'SubTDataPermission', 'SubCmdPermission'],
			columnSize: 6,
			headerProps: {
				sx: {
					padding: (theme) => theme.spacing(0.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5)
				}
			},
			fieldProps: {
				inlineLabel: true
			}
		},
		{
			header: 'Publish',
			fields: ['Publish', 'DataPermission', 'TDataPermission', 'CmdPermission', 'PublishDeviceType'],
			columnSize: 6,
			headerProps: {
				sx: {
					padding: (theme) => theme.spacing(0.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5)
				}
			},
			fieldProps: {
				inlineLabel: true
			}
		},
		{
			fields: ['IsAuthorize', 'AllowUnauthorizedTopics'],
			columnSize: 12
		}
	],
	onFormLoad: ({ formik }) => {
		onChangeSubscription({ formik, value: formik.values.Subscription });
		onChangePublish({ formik, value: formik.values.Publish });
	},
	customizeSaveData: customizeSave,
	columns: [
		{ header: 'UniqueId', field: 'ClientRequestsId', width: 250, hidden: true },
		{ field: 'ClientName', header: 'ClientName', width: 250, required: true },
		{ field: 'HospitalName', header: 'HospitalName1', width: 150, lookup: 'Hospital', required: true },
		{
			field: 'EquipmentType',
			header: 'DeviceType',
			width: 180,
			pdfExportWidth: 60,
			lookup: 'DeviceType',
			required: true,
			onChange: populateTopic
		},
		{
			field: 'LinkToTrackingSystems',
			header: 'LinkToTrackingSystems',
			width: 200,
			pdfExportWidth: 50,
			lookup: 'LinkToTrackingSystems',
			inputWhen: [{ field: 'EquipmentType', op: 'nin', value: ['CT', 'ETS', 'T'] }],
			renderCell: ({ value, colDef }) => {
				const combos = colDef.getCombos();
				const LinkToTrackingSystems = combos?.LinkToTrackingSystems;
				let DisplayValue = '';
				LinkToTrackingSystems.forEach((item) => {
					if (item.LookupId === value) DisplayValue = item.DisplayValue;
				});
				return DisplayValue;
			},
			required: [{ field: 'EquipmentType', op: 'nin', value: ['CT', 'ETS', 'T'] }],
		},
		{
			field: 'LinkToRFIDSystems',
			header: 'LinkToRFIDSystems',
			width: 200,
			pdfExportWidth: 50,
			lookup: 'LinkToRFIDSystems',
			hidden: true,
			inputWhen: [{ field: 'EquipmentType', op: 'in', value: ['CT', 'ETS', 'T'] }],
			renderCell: ({ row, value, colDef }) => {
				const combos = colDef.getCombos();
				const LinkToRFIDSystems = combos?.LinkToRFIDSystems;
				let DisplayValue = '';
				if (LinkToRFIDSystems) {
					LinkToRFIDSystems.find((item) =>
						item.LookupId === value ? (DisplayValue = item.DisplayValue) : (DisplayValue = '')
					);
				}
				return DisplayValue;
			}
		},
		{
			field: 'SerialNumber',
			header: 'SerialNumberSecond',
			width: 150,
			pdfExportWidth: 60,
			readOnly: [{ field: 'EquipmentType', op: 'in', value: ['CT', 'ETS', 'T', 'RM'] }],
			required: [{ field: 'EquipmentType', op: 'nin', value: ['CT', 'ETS', 'T', 'RM'] }],
			onChange: onChangeSerialNumber
		},
		{ Header: 'IP Address', field: 'IpAddress', header: 'IPAddress', width: 150, pdfExportWidth: 100 },
		{ field: 'MachineName', header: 'DeviceName', width: 150, pdfExportWidth: 50, },
		{ field: 'MacAddress', header: 'LAN1MACAddress', width: 150, hidden: true },
		{
			field: "LAN2MACAddress", header: 'LAN2MACAddress', width: 150, pdfExportWidth: 50
		},
		{
			field: 'DeviceFamily',
			header: 'DeviceFamily',
			width: 150,
			pdfExportWidth: 50,
			customizeInput: ({ Input, inputProps }) => {
				inputProps.fieldLabel = strings.DeviceFamilyLabel;
				return <Input {...inputProps} />;
			}
		},
		{
			field: 'DeviceModel',
			header: 'DeviceModel',
			width: 150,
			pdfExportWidth: 50,
			//  hidden:true,
			customizeInput: ({ Input, inputProps }) => {
				inputProps.fieldLabel = strings.DeviceModelLabel;
				return <Input {...inputProps} />;
			}
		},
		{
			field: 'Subscription',
			header: 'Subscribe',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'SubTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			onCreateOption: onCreateOption(consts.LookupType.SubTopics),
			onChange: onChangeSubscription,
			autocompleteValueFormatter,
			customizeInput,
			autocompleteValueParser: (value, options) => {
				let valueToShow = []
				const valuesToRemove = ['+/data', '+/cmd', '+/tdata'];
				if (value.length) {
					valueToShow = value.filter(item => !valuesToRemove.includes(item));
				}
				return valueToShow
			}
		},
		{
			field: 'SubDataPermission',
			header: 'Datatopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'DataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.DataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(consts.TopicType.DataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Subscription', topic: '+/data' })
		},
		{
			field: 'SubTDataPermission',
			header: 'Telemetrytopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'TDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.TDataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(topicType.TelemetryDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Subscription', topic: '+/tdata' })
		},
		{
			field: 'SubCmdPermission',
			header: 'Commandtopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'CMDDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.CMDDataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(consts.TopicType.CommandDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Subscription', topic: '+/cmd' })
		},
		//Publish Columns
		{
			field: 'Publish',
			header: 'Publish',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'PubTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			onCreateOption: onCreateOption(consts.LookupType.PubTopics),
			onChange: onChangePublish,
			autocompleteValueFormatter,
			autocompleteValueParser: (value, options) => {
				let valueToShow = []
				const valuesToRemove = ['+/data', '+/cmd', '+/tdata'];
				if (value.length) {
					valueToShow = value.filter(item => !valuesToRemove.includes(item));
				}
				return valueToShow
			},
			customizeInput
		},
		{
			field: 'TDataPermission',
			header: 'Telemetrytopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'TDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.TDataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.TelemetryDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Publish', topic: '+/tdata' })
		},
		{
			field: 'PublishDeviceType',
			header: 'CommandDeviceType',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'DeviceType',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.CommandDataWildcard)
		},
		{
			field: 'DataPermission',
			header: 'Datatopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'DataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.DataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.DataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Publish', topic: '+/data' })
		},
		{
			field: 'CmdPermission',
			header: 'Commandtopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'CMDDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.CMDDataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.CommandDataWildcard),
			onChange: ({ formik, value }) => onChangeTopic({ formik, value, key: 'Publish', topic: '+/cmd' })
		},
		{ field: 'LastConnection', header: 'LastConnection', type: 'dateTime', width: 200, pdfExportWidth: 50, isLocal: true },
		{
			field: 'IsActive',
			header: 'Active',
			type: 'bool',
			width: 120,
			pdfExportWidth: 50,
			filterable: false,
			renderCell: ({ value }) => {
				return <Bull value={value} />;
			}
		},
		{
			field: 'IsAuthorize',
			header: 'Authorized',
			type: 'bool',
			width: 75,
			pdfExportWidth: 50,
			hide: true,
			hidden: true,
			excludeOnGrid: true
		},
		{
			field: 'AllowUnauthorizedTopics',
			header: 'AllowUnauthorizedTopics',
			type: 'bool',
			width: 75,
			pdfExportWidth: 50,
			hide: true,
			hidden: true,
			excludeOnGrid: true
		},
		...(!isLimitedUser()
			? [
				{
					field: 'Delete',
					label: 'Command',
					width: 150,
					type: 'actions',
					isNotformfield: true,
					action: 'delete',
					filterable: false,
					renderCell: (params) => (
						<Button
							onClick={() => params.colDef.deleteRow(params)}
							color="error"
							variant="contained"
							title={strings.Delete}
							size="small"
						>
							{strings.Delete}
						</Button>
					)
				}
			]
			: [])
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A3'
		}
	}
});

export default model.createFormBase();
